import {Button, Modal, Select} from 'antd';
import {ReactElement, useState} from 'react';

import {useLocale} from '../../../../../../../../provider/locale/locale-hook';
import {Locale} from '../../../../../../../../provider/locale/localization';
import {useSnackbar} from '../../../../../../../../provider/snackbar/snackbar-hook';
import {
    ReviewStatusType,
    updateReviewStatus,
    useReviewStatusList,
} from '../../../../../../../../service/reviews/reviews-statuses';
import {ReviewDataType} from '../../../../../../../../service/reviews/reviews-type';
import {handleFilterOption} from '../../../../../../../../util/antd/select-helper';
import {ReviewDataWithCatalogType} from '../../../review-list-type';
import {processBatch} from '../../review-helper';

import * as styles from './status-change-modal.scss';

const {Option} = Select;

type PropsType = {
    onCancel: () => void;
    onSuccess?: () => void;
    updateReview: (reviewId: number, updateData: Partial<ReviewDataType>) => void;
    selectedReviews: Array<ReviewDataWithCatalogType>;
};

export function StatusChangeModal(props: PropsType): ReactElement {
    const {onCancel, onSuccess, updateReview, selectedReviews} = props;
    const [selectedStatus, setSelectedStatus] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    const {localeName} = useLocale();
    const {snackbar} = useSnackbar();

    const {data: reviewStatusList, isFetching: isReviewStatusListInProgress} = useReviewStatusList(localeName);

    async function handleOk() {
        if (selectedStatus) {
            setIsLoading(true);

            try {
                await processBatch(selectedReviews, 50, async (review) => {
                    await updateReviewStatus(review.id, {status: selectedStatus});
                    updateReview(review.id, {processStatus: selectedStatus});
                });

                snackbar.success(<Locale stringKey="REVIEWS__STATUS_CHANGE_SUCCESS" />);

                if (onSuccess) {
                    onSuccess();
                } else {
                    onCancel();
                }
            } catch {
                snackbar.error(<Locale stringKey="ERROR__SOMETHING_WENT_WRONG" />);
            } finally {
                setIsLoading(false);
            }
        }
    }

    return (
        <Modal
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    <Locale stringKey="POPUP__BUTTON__CANCEL" />
                </Button>,
                <Button disabled={!selectedStatus} key="ok" loading={isLoading} onClick={handleOk} type="primary">
                    <Locale stringKey="TEXT__APPLY" />
                </Button>,
            ]}
            onCancel={onCancel}
            open
            title={<Locale stringKey="REVIEWS__FILTER__SELECT_A_STATUS" />}
        >
            <Select
                className={styles.StatusChangeModal_select}
                filterOption={handleFilterOption}
                loading={isReviewStatusListInProgress}
                onChange={setSelectedStatus}
                optionFilterProp="children"
                placeholder={<Locale stringKey="REVIEWS__FILTER__SELECT_A_STATUS" />}
                showSearch
                value={selectedStatus}
            >
                {reviewStatusList?.statuses.map((reviewStatus: ReviewStatusType) => (
                    <Option key={reviewStatus.statusCode} value={reviewStatus.statusCode}>
                        {reviewStatus.title}
                    </Option>
                ))}
            </Select>
        </Modal>
    );
}
